/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlSubFamilyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceControlSubFamilyQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceControlSubFamilyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlSubFamilyQueryOperator>): ComplianceControlSubFamilyQueryOperator {
        let obj = Object.assign(new ComplianceControlSubFamilyQueryOperator(), model);
        ComplianceControlSubFamilyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlSubFamilyQueryOperator>): ComplianceControlSubFamilyQueryOperator {
        if (!model) return null;
        return ComplianceControlSubFamilyQueryOperator.newInstance(<ComplianceControlSubFamilyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlSubFamilyQueryOperator) {
        if (!obj) return;

        models.ComplianceControlSubFamilyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlSubFamilyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlSubFamilyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Control sub families to include
     */
    control_sub_families: Array<string>;

}
